import { bool, func, node, oneOfType, string } from "prop-types";
import styled, { css } from "styled-components/macro";
import { hideVisually, rem } from "polished";
import { fonts } from "../../../styles/Styles.variables";

const baseStyles = css`
  color: ${({ disabled, theme }) =>
    disabled ? theme.input.disabledText : "inherit"};
  display: block;
  font-size: ${({ size }) => {
    switch (size) {
      case "smaller":
        return rem("12px");
      case "small":
        return rem("13px");
      case "medium":
        return rem("22px");
      default:
        return rem("15px");
    }
  }};
  font-weight: ${({ size }) => {
    switch (size) {
      case "medium":
      case "smaller":
        return fonts.weights.bold;
      default:
        return fonts.weights.normal;
    }
  }};
  line-height: 1;
  margin-bottom: ${({ size }) => {
    switch (size) {
      case "smaller":
        return rem("5px");
      case "small":
        return rem("8px");
      case "medium":
        return rem("0px");
      default:
        return rem("6px");
    }
  }};
  text-transform: uppercase;
  white-space: ${({ whitespace }) => (!!whitespace ? whitespace : "auto")};

  small {
    text-transform: none;
  }
`;

const requiredStyles = css`
  &:after {
    color: ${({ theme }) => theme.error.color};
    content: "*";
  }
`;

const Label = styled(
  ({ children, block, srOnly, whitespace, tag: Component, ...rest }) => (
    <Component {...rest}>{children}</Component>
  )
)`
  ${({ srOnly }) => (srOnly ? hideVisually() : baseStyles)};
  ${({ required, srOnly }) => (required && !srOnly ? requiredStyles : null)}
`;

Label.propTypes = {
  children: node.isRequired,
  disabled: bool,
  htmlFor: string,
  required: bool,
  size: string,
  srOnly: bool,
  tag: oneOfType([node, func, string]),
};

Label.defaultProps = {
  disabled: false,
  required: false,
  srOnly: false,
  tag: "label",
};

export default Label;
